
// import { Button, Card, Typography, Space } from "antd";
// import "./GameNotificationPopup.scss";
// import PropTypes from "prop-types";
// import fifa from "../../../assets/images/fifa.svg";
// import { useTranslation } from "react-i18next";
// import { postApiRequest } from "../../../services/postApiRequest";
// import { END_POINTS } from "../../../Helper/Constant";
// import { hideLoader, showLoader } from "../../../features/loader/loaderSlice";
// import { useDispatch } from "react-redux";
// import { showToast } from "../../../shared/sharedComponents/ToasterMessage/ToasterMessage";
// import useSocket from "../../../hooks/useSocket";
// import { useEffect, useState } from "react";
// import notification from "../../../assets/notification-sound/notification.mp3";
// import { useNavigate } from "react-router-dom";

// const { Text, Title } = Typography;

// const GameNotificationPopup = () => {
//     const { t } = useTranslation("common");
//     const dispatch = useDispatch();
//     const socketConnection = useSocket();
//     const { socket, isReady } = socketConnection;
//     const [audio] = useState(new Audio(notification));

//     const [invitations, setInvitations] = useState([]);
//     const navigate = useNavigate();

//     useEffect(() => {
//         getInvitations();
//     }, [socket, isReady]);


//     const getInvitations = async () => {
//         console.log('getInvitations: called');
//         if (socket && isReady) {
//             console.log('socket && isReady:inside the if ', socket && isReady);
//             const handleInvitations = async ({ numberOfInvitations, invitations }) => {
//                 console.log('invitations: ', invitations);
//                 if (numberOfInvitations > 0) {
//                     try {
//                         await audio.play();
//                         console.log("Sound played successfully");
//                     } catch (error) {
//                         console.error("Error playing sound:", error);
//                     }
//                 }
//                 setInvitations(invitations);
//             };

//             socket.on("invitations", handleInvitations);
//             socket.on("invitation-accepted", (acceptedInvitation) => {
//                 console.log('acceptedInvitation: ', acceptedInvitation);
//                 navigate(`/one-to-one-message/${acceptedInvitation?._id}`, { state: { data: acceptedInvitation } });
//             })

//             return () => {
//                 socket.off("invitations", handleInvitations);
//             };
//         }
//     }


//     const handleClearAllInvitations = async () => {
//         dispatch(showLoader())
//         try {
//             const response = await postApiRequest(END_POINTS.CLEAR_INVITATIONS)
//             console.log('response: ', response);
//             if (response?.success) {
//                 console.log('response: ', response);
//             }
//         } catch (error) {
//             console.log('error: ', error);
//             showToast(error?.error?.message, "error");
//         } finally {
//             dispatch(hideLoader());
//         }
//     }


//     const onDeclineInvite = async (item) => {
//         dispatch(showLoader())
//         try {
//             const response = await postApiRequest(`${END_POINTS.DECLINE_INVITATION}/${item?._id}`);
//             console.log('response: ', response);
//             if (response?.success) {
//                 showToast(response?.message, "success");
//                 getInvitations();
//             }
//         } catch (error) {
//             showToast(error?.response?.message, "error");

//         } finally {
//             dispatch(hideLoader())
//         }
//     };

//     const onInviteAccept = async (item) => {
//         dispatch(showLoader());
//         try {
//             const response = await postApiRequest(`${END_POINTS.ACCEPT_INIVITATION}/${item?._id}`);
//             if (response?.success) {
//                 showToast(response?.message, "success");
//                 navigate(`/one-to-one-message/${item?._id}`, { state: { data: item } });
//             }
//         } catch (error) {
//             console.log('error: ', error);
//             showToast(error?.error?.message, "error")
//         } finally {
//             dispatch(hideLoader());
//         }
//     };

//     return (
//         <>
//             <div className="game-notification-popup-container">
//                 {invitations?.length > 1 ?
//                     <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
//                         <Button className="clear-btn-one-to-one" onClick={handleClearAllInvitations}>{t("one_to_one.clear_all")}</Button>
//                     </div>
//                     : null}

//                 {invitations?.length > 0 &&
//                     invitations.map((item, index) => (
//                         <Card key={item._id || index} className="game-notification-popup">
//                             <div className="popup-content">
//                                 <h4 className="invited-by">{t("one_to_one.invited_by")} {item?.invitedBy?.userName}</h4>
//                                 <div className="game-info">
//                                     <div style={{ display: "flex", gap: "10px" }}>
//                                         <img
//                                             src={item?.gameTypeId?.logo || fifa}
//                                             alt="Game Icon"
//                                             className="game-icon"
//                                             loading="lazy"
//                                         />
//                                         <div className="game-details">
//                                             <Title level={5} className="game-title">
//                                                 {item?.gameTypeId?.name}
//                                             </Title>
//                                             <Text className="platform">
//                                                 {item?.gameTypeId?.platform}
//                                             </Text>
//                                         </div>
//                                     </div>
//                                     <Space className="action-buttons">
//                                         <Button className="go-button" onClick={() => onInviteAccept(item)}>
//                                             {t("one_to_one.accept")}
//                                         </Button>
//                                         <Button
//                                             type="primary"
//                                             className="chat-button"
//                                             onClick={() => onDeclineInvite(item)}
//                                         >
//                                             {t("one_to_one.decline")}
//                                         </Button>
//                                     </Space>
//                                 </div>
//                             </div>
//                         </Card>
//                     ))}
//             </div>
//         </>
//     );
// };

// GameNotificationPopup.propTypes = {
//     invitations: PropTypes.arrayOf(
//         PropTypes.shape({
//             _id: PropTypes.string.isRequired,
//             invitedBy: PropTypes.shape({
//                 userName: PropTypes.string.isRequired,
//             }),
//             gameTypeId: PropTypes.shape({
//                 name: PropTypes.string.isRequired,
//                 platform: PropTypes.string.isRequired,
//             }),
//         })
//     ),
// };


// export default GameNotificationPopup;

import { Button, Card, Typography, Space } from "antd";
import "./GameNotificationPopup.scss";
import PropTypes from "prop-types";
import fifa from "../../../assets/images/fifa.svg";
import { useTranslation } from "react-i18next";
import { postApiRequest } from "../../../services/postApiRequest";
import { END_POINTS } from "../../../Helper/Constant";
import { hideLoader, showLoader } from "../../../features/loader/loaderSlice";
import { useDispatch } from "react-redux";
import { showToast } from "../../../shared/sharedComponents/ToasterMessage/ToasterMessage";
import useSocket from "../../../hooks/useSocket";
import { useEffect, useState, useRef, useCallback } from "react";
import notification from "../../../assets/notification-sound/notification.mp3";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const GameNotificationPopup = () => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();
    const socketConnection = useSocket();
    const { socket, isReady } = socketConnection;
    const audioRef = useRef(new Audio(notification));

    // CRITICAL: Track if listeners are set up to prevent duplicates
    const listenersSetupRef = useRef(false);
    const socketIdRef = useRef(null);

    const [invitations, setInvitations] = useState([]);
    const navigate = useNavigate();

    // Memoize handlers to prevent recreation
    const handleInvitations = useCallback(async ({ numberOfInvitations, invitations }) => {
        console.log('Received invitations:', invitations);

        // Play sound only if there are new invitations
        if (numberOfInvitations > 0) {
            try {
                await audioRef.current.play();
                console.log("Sound played successfully");
            } catch (error) {
                console.error("Error playing sound:", error);
            }
        }

        setInvitations(invitations);
    }, []);

    const handleInvitationAccepted = useCallback((acceptedInvitation) => {
        console.log('Invitation accepted:', acceptedInvitation);
        navigate(`/one-to-one-message/${acceptedInvitation?._id}`, {
            state: { data: acceptedInvitation }
        });
    }, [navigate]);

    // FIXED: Super strict socket listener setup
    useEffect(() => {
        // Guard 1: Check if socket and isReady exist
        if (!socket || !isReady) {
            console.log('Socket not ready, skipping listener setup');
            return;
        }

        // Guard 2: Check if listeners already set up for this socket instance
        const currentSocketId = socket.id;
        if (listenersSetupRef.current && socketIdRef.current === currentSocketId) {
            console.log('Listeners already set up for this socket, skipping');
            return;
        }

        // Guard 3: Clean up any existing listeners before setting up new ones
        if (listenersSetupRef.current) {
            console.log('Cleaning up old listeners before setting up new ones');
            socket.off("invitations");
            socket.off("invitation-accepted");
        }

        console.log('=== SETTING UP INVITATION LISTENERS - SOCKET ID:', currentSocketId, '===');

        // Mark as set up
        listenersSetupRef.current = true;
        socketIdRef.current = currentSocketId;

        // Register socket listeners
        socket.on("invitations", handleInvitations);
        socket.on("invitation-accepted", handleInvitationAccepted);

        // CRITICAL: Cleanup function
        return () => {
            console.log('=== CLEANING UP INVITATION LISTENERS ===');
            socket.off("invitations", handleInvitations);
            socket.off("invitation-accepted", handleInvitationAccepted);
            listenersSetupRef.current = false;
            socketIdRef.current = null;
        };
    }, [socket, isReady, handleInvitations, handleInvitationAccepted]);

    const handleClearAllInvitations = async () => {
        dispatch(showLoader());
        try {
            const response = await postApiRequest(END_POINTS.CLEAR_INVITATIONS);
            console.log('Clear invitations response:', response);
            if (response?.success) {
                setInvitations([]);
                showToast(response?.message || "All invitations cleared", "success");
            }
        } catch (error) {
            console.error('Error clearing invitations:', error);
            showToast(error?.error?.message || "Failed to clear invitations", "error");
        } finally {
            dispatch(hideLoader());
        }
    };

    const onDeclineInvite = async (item) => {
        dispatch(showLoader());
        try {
            const response = await postApiRequest(`${END_POINTS.DECLINE_INVITATION}/${item?._id}`);
            console.log('Decline invitation response:', response);
            if (response?.success) {
                showToast(response?.message, "success");
                // Remove declined invitation from local state
                setInvitations(prev => prev.filter(inv => inv._id !== item._id));
            }
        } catch (error) {
            console.error('Error declining invitation:', error);
            showToast(error?.response?.message || "Failed to decline invitation", "error");
        } finally {
            dispatch(hideLoader());
        }
    };

    const onInviteAccept = async (item) => {
        dispatch(showLoader());
        try {
            const response = await postApiRequest(`${END_POINTS.ACCEPT_INIVITATION}/${item?._id}`);
            if (response?.success) {
                showToast(response?.message, "success");
                navigate(`/one-to-one-message/${item?._id}`, { state: { data: item } });
            }
        } catch (error) {
            console.error('Error accepting invitation:', error);
            showToast(error?.error?.message || "Failed to accept invitation", "error");
        } finally {
            dispatch(hideLoader());
        }
    };

    return (
        <>
            <div className="game-notification-popup-container">
                {invitations?.length > 1 && (
                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                        <Button
                            className="clear-btn-one-to-one"
                            onClick={handleClearAllInvitations}
                        >
                            {t("one_to_one.clear_all")}
                        </Button>
                    </div>
                )}

                {invitations?.length > 0 &&
                    invitations.map((item, index) => (
                        <Card key={item._id || index} className="game-notification-popup">
                            <div className="popup-content">
                                <h4 className="invited-by">
                                    {t("one_to_one.invited_by")} {item?.invitedBy?.userName}
                                </h4>
                                <div className="game-info">
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <img
                                            src={item?.gameTypeId?.logo || fifa}
                                            alt="Game Icon"
                                            className="game-icon"
                                            loading="lazy"
                                        />
                                        <div className="game-details">
                                            <Title level={5} className="game-title">
                                                {item?.gameTypeId?.name}
                                            </Title>
                                            <Text className="platform">
                                                {item?.gameTypeId?.platform}
                                            </Text>
                                        </div>
                                    </div>
                                    <Space className="action-buttons">
                                        <Button
                                            className="go-button"
                                            onClick={() => onInviteAccept(item)}
                                        >
                                            {t("one_to_one.accept")}
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="chat-button"
                                            onClick={() => onDeclineInvite(item)}
                                        >
                                            {t("one_to_one.decline")}
                                        </Button>
                                    </Space>
                                </div>
                            </div>
                        </Card>
                    ))}
            </div>
        </>
    );
};

GameNotificationPopup.propTypes = {
    invitations: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string.isRequired,
            invitedBy: PropTypes.shape({
                userName: PropTypes.string.isRequired,
            }),
            gameTypeId: PropTypes.shape({
                name: PropTypes.string.isRequired,
                platform: PropTypes.string.isRequired,
            }),
        })
    ),
};

export default GameNotificationPopup;